import { atom } from 'recoil';

import { Tabs } from '../../pages/docASR/components/atomicComponent/WuLab/BigModel';

const allsKeywordState = atom({
  key: 'bigModule/allsKeyword',
  default: false,
});

/**
 *  *************************************************************
 *  **********************  @rdm 新增-起始   *********************
 *  *************************************************************
 */

/** 当前展示的大模型标签页 */
const currentBigModelTabState = atom<Tabs>({
  key: 'bigModule/currentBigModelTab',
  default: Tabs.Summary,
});

/**
 *  *************************************************************
 *  **********************  @rdm 新增-结束   *********************
 *  *************************************************************
 */

export { allsKeywordState, currentBigModelTabState };
